(() => {
  if (window.vicsProductToolsReady) return;
  window.vicsProductToolsReady = true;
  let lastTrigger;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vics-size-guide]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.vicsSizeGuide);
      if (dialog && !dialog.open) { lastTrigger = trigger; dialog.showModal(); }
      return;
    }
    const closer = event.target.closest('[data-vics-dialog-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.vics-size-guide')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('dialog.vics-size-guide') && lastTrigger?.isConnected) lastTrigger.focus();
  }, true);
})();
